export default __webpack_public_path__ + "static/media/Pink pop_primary.c414b653.jpg";